export const MediaCallsPeriodEnum = Object.freeze({
  MONTH_AGO: 'MONTH-AGO',
  MONTH_CURRENT: 'MONTH-CURRENT',
  MONTH_PREVIOUS: 'MONTH-PREVIOUS',
  TODAY: 'TODAY',
  WEEK_AGO: 'WEEK-AGO',
  WEEK_CURRENT: 'WEEK-CURRENT',
});
